import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import PageBaseLayout from '../layouts/PageBaseLayout';
import { DataGrid, type GridColDef } from '@mui/x-data-grid';
import { supabase } from '../supabase-client';
import useDialog from '../hooks/useDialog';
import useBackdrop from '../hooks/useBackdrop';
import useSnackbar from '../hooks/useSnackbar';
import CreateBackendUserDialog from '../components/CreateBackendUserDialog';
import { useEffect, useState } from 'react';
import type { BackendUser } from '../models/types';

export default function UserManagement() {
  const backdrop = useBackdrop();
  const snackbar = useSnackbar();
  const dialog = useDialog();
  const [users, setUsers] = useState<BackendUser[]>([]);
  const columns: GridColDef<{}>[] = [
    // {
    //   field: 'merchant_id',
    //   headerName: 'Brand ID',
    //   width: 120,
    //   editable: true,
    // },
    {
      field: 'merchant_name',
      headerName: 'Brand',
      width: 200,
      editable: true,
    },
    {
      field: 'user_role',
      headerName: 'Role',
      width: 150,
      editable: true,
    },
    {
      field: 'email',
      headerName: 'Email',
      width: 300,
      editable: true,
    },
  ];
  const rows = [
    {
      id: 1,
      username: 'User1',
      role: 'Employee',
    },
    {
      id: 2,
      username: 'User2',
      role: 'Admin',
    },
  ];

  const getUserData = async () => {
    backdrop.handleBackdropOpen();

    try {
      const { data, error } = await supabase
        .schema('admin_backend')
        .from('backend_users_view')
        .select('*');

      if (error) {
        console.error('Error fetching brand user:', error);
        throw error;
      }

      setUsers(data);
    } catch (error) {
      const errorCast = error as Error;
      console.error(errorCast.stack);
      snackbar.handleSnackbarOpen(errorCast.message, 'error');
    }

    backdrop.handleBackdropClose();
  };

  useEffect(() => {
    getUserData();
  }, []);

  return (
    <PageBaseLayout
      title="User Management"
      actions={
        <>
          {' '}
          <Button
            startIcon={<AddIcon />}
            onClick={async () => {
              dialog.handleDialogOpen(
                <CreateBackendUserDialog getUserData={getUserData} />,
                'Create Backend User',
              );
            }}>
            Create User
          </Button>
        </>
      }>
      <DataGrid columns={columns} rows={users} />
    </PageBaseLayout>
  );
}
